/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {toAbsoluteUrl} from '../../../_designereyes/helpers'
import {PageTitle} from '../../../_designereyes/layout/core'
import {useAuth} from '../../../app/modules/auth'

import axios from 'axios'
import 'daterangepicker/daterangepicker.css'
import 'daterangepicker'
import {API_URL} from '../../../app/modules/auth/core/_requests'
import {ChangelogWrapper} from '../documentsPage/Changelog'

const DashboardPage: FC = () => {
  const {currentUser} = useAuth()

  return <></>
}

const DebugUserPage: FC = () => {
  const {currentUser} = useAuth()

  return (
    <>
      <div>
        <ChangelogWrapper />
      </div>
    </>
  )
}

export const DashboardWrapper: FC = () => {
  const {currentUser} = useAuth()

  return (
    <>
      <PageTitle>Dashboard</PageTitle>
      <DebugUserPage />
      <DashboardPage />
    </>
  )
}
